export const TokenType = Object.freeze({
  None: 'None',
  Register: 'Register',
  User: 'User',
  Public: 'Public',
});
